import { render, staticRenderFns } from "./homeSalesGroups.vue?vue&type=template&id=60e039d4&"
import script from "./homeSalesGroups.vue?vue&type=script&lang=js&"
export * from "./homeSalesGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports